import { RuleTableConfiguration } from "./RuleTableConfiguration";
import { RuleTableEditContext } from "./RuleTableEditContext";
import { TestResultDataType } from "../../../Common/Testing/TestResultDataType";
import { BaseTestResultData } from "../../../Common/Testing/BaseTestResultData";

export class RuleTableTestResult extends BaseTestResultData {
    type: TestResultDataType = TestResultDataType.RULE_TABLE;
    editContext?: RuleTableEditContext;

    private _definition?: RuleTableConfiguration;

    get definition(): RuleTableConfiguration | undefined {
        return this._definition;
    }

    set definition(definition: RuleTableConfiguration | undefined) {
        this._definition = definition;

        if (this._definition) {
            this.editContext = new RuleTableEditContext(this._definition);
        }
    }
}

export class RuleTableRowTestResult extends BaseTestResultData {
    type: TestResultDataType = TestResultDataType.RULE_TABLE_ROW;
}

export class RuleTableCellTestResult extends BaseTestResultData {
    type: TestResultDataType = TestResultDataType.RULE_TABLE_COLUMN;
}
